import apiClient from './index'
import axiosInstance from './index'
import { useUserStore } from '@/stores/userStore'
import Cookies from 'universal-cookie'
import { axiosInstanceAdmin } from './indexAdmin'
import { STAGE } from '@/env'

export const VerifyUsers = async () => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.get('/verify', {
      headers: {
        Authorization: `Bearer ${userStore?.token}`,
      },
    })
    // console.log(response)

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    if (window.location.pathname === '/' || window.location.pathname === '/company/login') {
      console.log('Irrelevant')
    } else {
      window.location.href = '/'
      const userStore = useUserStore()
      userStore.clearUser()
      localStorage.clear()
    }
    throw error
  }
}

export const VerifyUsersCreateUser = async () => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.get(
      '/verify',

      {
        headers: {
          Authorization: `Bearer ${userStore?.token}`,
        },
      }
    )
    // console.log(response)

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)

    throw error
  }
}

export const toggleAccountStatus = async (name: string) => {
  try {
    const response = await apiClient.put(`/account/toggle_disable?accountName=${name}`)
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error toggling  accounts:', error)
    alert(error)
    throw error
  }
}

export const toggleAccountProductStatus = async (accountName: string, productName: string) => {
  try {
    const response = await apiClient.put(
      `amount/product/toggle_disable?productName=${productName}&accountName=${accountName}`
    )
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const toggleProductForAccount = async (accountName: string, productName: string) => {
  const userStore = useUserStore()
  try {
    const response = await apiClient.put(
      `/account/products/toggle_disable?accountName=${accountName}&productName=${productName}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${userStore?.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const toggleProductStatus = async (name: string) => {
  try {
    const response = await apiClient.put(`/product/toggle_disable?productName=${name}`)
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const fetchProducts = async () => {
  const userStore = useUserStore()
  try {
    const response = await apiClient.get('/product', {
      headers: {
        Authorization: `Bearer ${userStore?.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const fetchClients = async () => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.get(`/clients`, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const fetchAccountProductsClient = async (accountName: string, productName: string) => {
  try {
    // URL-encode productName to handle slashes in child product paths
    const encodedProductName = encodeURIComponent(productName)
    const response = await axiosInstance.get(
      `/account/products/${accountName}/${encodedProductName}`
    )
    // console.log(response);

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const updateProductForAccount = async (data: any) => {
  try {
    // URL-encode productName to handle slashes in child product paths
    const encodedProductName = encodeURIComponent(data.productName)
    const response = await apiClient.put(
      `/account/products/${data.accountName}/${encodedProductName}`,
      { config: data.config },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not create account Products', error)
    throw error
  }
}

export const sampleCreateProductsForAccount = async (data: object) => {
  try {
    const response = await apiClient.post('/account/products', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not create account Products', error)
    throw error
  }
}

export const fetchAccountProductsConfig = async (productConfig: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.get(`/product/config/`, {
      params: {
        productName: productConfig,
      },

      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const fetchAccountsProduct = async (accountName: string) => {
  const userStore = useUserStore()
  try {
    const response = await apiClient.get(`/account/products`, {
      params: {
        accountName: accountName,
      },

      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const createAccountProductsConfig = async (data: object) => {
  try {
    const response = await apiClient.post('/product/config', data)
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not create account Products', error)
    alert('Failed to create account product.')
    throw error
  }
}

export const updateAccountProductsConfig = async (data: object) => {
  const cookie = new Cookies()
  const admin = cookie.get('admin')
  try {
    const response = await axiosInstanceAdmin.put('/product/config', data, {
      headers: {
        Authorization: `Bearer ${admin?.idToken}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not update account Products', error)
    alert('Failed to update account product.')
    throw error
  }
}

export const createAccount = async (accountData: object) => {
  try {
    const response = await apiClient.post('/account', accountData)
    // console.log("Account DataSubmitted", response);
    return response.data
  } catch (error) {
    console.error('Could not create account', error)
    alert('Failed to create account.')
    throw error
  }
}

export const updateAccount = async (payload: object) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.put('/account', payload, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log("Account Updated successfully", response);
    return response.data
  } catch (error) {
    console.error('Could not update account', error)
    // alert("Failed to update account.");

    throw error
  }
}

export const fetchAccountSingle = async (accountName: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.get(`/account`, {
      params: {
        accountName: accountName,
      },
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const fetchAllUsers = async () => {
  const userStore = useUserStore()
  try {
    const userStore = useUserStore()
    const token = userStore.token
    const response = await axiosInstance.get('/get-all-users', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    console.log(response.status)

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    console.log(error.status)
    console.log(error.response.status)
    throw error
  }
}

export const SendUserName = async (username: string, group: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.post(
      '/add-user-group',
      { username: username, group: group },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    console.log('User Name Submitted', response)
    return response.data
  } catch (error) {
    console.error('Could not create User', error)
    alert('Failed to send Username.')
    throw error
  }
}

export const SendAdminName = async (username: string, email: string) => {
  try {
    const response = await apiClient.post('/account/admin/add-admin-group', {
      username: username,
      email: email,
    })
    console.log('Admin Name Submitted', response)
    alert('Admin Created Successfully')
    return response.data
  } catch (error) {
    console.error('Could not create User', error)
    alert('Failed to send Username.')
    throw error
  }
}

export const fetchAllAdmins = async () => {
  try {
    // await VerifyAdmin()
    const response = await axiosInstance.get('/admin/get-all-admins')
    console.log(response.status)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    console.log(error.status)
    console.log(error.response.status)
    throw error
  }
}

export const LogoutFunc = async () => {
  try {
    const response = await axiosInstance.get('/admin/logout')
    console.log(response.status)
    console.log('logout func', response)
    alert(response?.data?.message)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const LogoutFuncUser = async () => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.get('/logout', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })

    return response.data
  } catch (error) {
    window.location.href = '/'
    userStore.clearUser()

    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const deleteUser = async (username: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.delete('/delete-user', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
      },
      params: {
        username: username,
      },
    })

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const toggleUserStatusSetActiveNow = async (username: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.put(
      `/enable-user`,
      { username },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error Enable User status:', error)
    throw error
  }
}
export const toggleUserStatusSetDeActiveNow = async (username: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.put(
      `/disable-user`,
      { username },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error Disable user status:', error)
    throw error
  }
}

export const updateRole = async (username: string, newRole: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstance.put(
      `/change-role`,
      {
        username: username,
        newRole: newRole,
        // isClient: isClient
      },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error toggling  accounts:', error)
    alert(error)
    throw error
  }
}

export const sendLogInfo = async (logInfo: object) => {
  const userStore = useUserStore()
  console.log(logInfo)
  try {
    const response = await axiosInstance.post(`/login-activity`, logInfo, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // alert("Success");

    return response.data
  } catch (error) {
    console.error('Error toggling  accounts:', error)
    // alert(error)
    throw error
  }
}
